import type VueRouter from 'vue-router';

export default function referrerGuard(router: VueRouter) {
  /**
   * 切换路由前记录referrer
   */
  router.beforeEach((to, from, next) => {
    const { protocol, host } = window.location;
    window.__vue_router_referrer__ = `${protocol}//${host}${from.fullPath}`;
    next();
  });
}
